/**
 * MEEKO Shopify Theme JavaScript
 * Handles: Back-to-top, Toast notifications, smooth scroll
 */

(function() {
  'use strict';

  // ============================================
  // Back to Top Button
  // ============================================
  var backToTopBtn = document.getElementById('backToTop');

  if (backToTopBtn) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 400) {
        backToTopBtn.classList.add('back-to-top--visible');
      } else {
        backToTopBtn.classList.remove('back-to-top--visible');
      }
    });

    backToTopBtn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ============================================
  // Toast Notification System
  // ============================================
  window.MeekoToast = {
    show: function(message, duration) {
      duration = duration || 3000;

      // Remove existing toast
      var existing = document.querySelector('.toast');
      if (existing) existing.remove();

      // Create toast
      var toast = document.createElement('div');
      toast.className = 'toast';
      toast.textContent = message;
      document.body.appendChild(toast);

      // Trigger animation
      requestAnimationFrame(function() {
        toast.classList.add('toast--visible');
      });

      // Auto-hide
      setTimeout(function() {
        toast.classList.remove('toast--visible');
        setTimeout(function() {
          if (toast.parentNode) toast.remove();
        }, 400);
      }, duration);
    }
  };

  // ============================================
  // AJAX Add to Cart (optional enhancement)
  // ============================================
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        // Show toast
        window.MeekoToast.show('Added ' + data.title + ' to cart');

        // Update cart count in header
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var countEls = document.querySelectorAll('.header__cart-count');
            countEls.forEach(function(el) {
              el.textContent = cart.item_count;
            });
            // Create count badge if it doesn't exist
            if (countEls.length === 0 && cart.item_count > 0) {
              var cartLink = document.querySelector('.header__action-link[aria-label="Cart"]');
              if (cartLink) {
                var badge = document.createElement('span');
                badge.className = 'header__cart-count';
                badge.textContent = cart.item_count;
                cartLink.appendChild(badge);
              }
            }
          });
      })
      .catch(function(err) {
        console.error('Add to cart failed:', err);
        window.MeekoToast.show('Failed to add item. Please try again.');
      });
    });
  });

  // ============================================
  // Smooth Section Scroll (for anchor links)
  // ============================================
  document.querySelectorAll('a[href*="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href.startsWith('#') || href.startsWith('/#')) {
        var targetId = href.replace('/', '').replace('#', '');
        var target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

})();
